import { render, staticRenderFns } from "./UsuarioAdminForm.vue?vue&type=template&id=ff041406&"
import script from "./UsuarioAdminForm.vue?vue&type=script&lang=js&"
export * from "./UsuarioAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports